import { joinURL } from 'ufo'
import type { ProviderGetImage } from '@nuxt/image'

export const getImage: ProviderGetImage = (
    src,
    { modifiers = {}, baseURL } = {}
) => {

    const baseSrc = src

    // 生成 Cloudflare Transformations 参数
    const params = []
    if (modifiers.width) params.push(`width=${modifiers.width}`)
    if (modifiers.height) params.push(`height=${modifiers.height}`)
    if (modifiers.quality) params.push(`quality=${modifiers.quality}`)
    if (modifiers.format) params.push(`format=${modifiers.format}`)

    // 拼接 Transformations 路径
    const transformPath = params.length > 0 ? `/cdn-cgi/image/${params.join(',')}` : ''

    // 提取 src 的路径部分（去除域名），避免重复拼接
    const url = new URL(baseSrc, baseURL || 'https://musics3.styletpff.com')
    const path = url.pathname

    // 生成最终 URL：原始域名 + Transformations + 路径
    return {
        url: joinURL(`${url.origin}`, transformPath, path)
    }
}
